import { PayloadAction } from "@reduxjs/toolkit";
import { UpsellState } from "../../models/UpsellsState";
import { GetUpsellsListPayload } from "../../payload/GetUpsellsList/GetUpsellsListPayload";

const getAdditionalListFetch = (state: UpsellState, action: PayloadAction<GetUpsellsListPayload>) => {
    state.isLoading = true;
}

export default getAdditionalListFetch;